<script>
import RawData from "@/components/widgets/raw-data.vue";
import { orderBy } from "lodash";
export default {
  components: {
    RawData,
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: "Ongoing"
    }
  },
  computed: {
    filtered(){
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.description.toUpperCase().includes(this.filter.toUpperCase()))
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (item.poNumber.toUpperCase().includes(this.filter.toUpperCase()))
            return item.poNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (item.supplierName.toUpperCase().includes(this.filter.toUpperCase()))
            return item.supplierName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (item.endUser.toUpperCase().includes(this.filter.toUpperCase()))
            return item.endUser
              .toUpperCase()
              .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    },
    isContract(){
      return this.status === "Pending Contracts" || this.status === "Approved Contracts";
    }
  },
  data() {
    return {
      filter: '',
      perPage: 10,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      uploadOptions: {
        type: "Purchase Order",
        placement: "lefttop",
        folder: "Property"
      },
      selectedTab: 0,
    };
  },
  methods: {
    checkDeliveryDate(deliveryDate, days) {
      var warningDays = days < 4 ? 1 : ~~(days / 4);
      var today = new Date();
      var nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + warningDays
      );
      if (deliveryDate <= today) return "expired";
      else if (deliveryDate < nextweek) return "warning";
      else return "ongoing";
    },
    hasExtensionWithStatus(item, type, status) {
      item.poDeliveryExtensions = item.poDeliveryExtensions || [];
      return item.poDeliveryExtensions.some(ext =>
        ext.type === type && ext.status === status
      );
    },
    selectedRowCheck(items) {
      var count = 0;
      items.forEach((item) => {
        item.toggleSelected && count++;
      });
      if (count > 0) return true;
      else return false;
    },
    uploadedFiles() {},
    deliveryClass(item) {
      if (this.checkDeliveryDate(new Date(item.expectedDelivery), item.numberOfDays) == 'ongoing') {
        return 'bg-success'
      }
      if(this.checkDeliveryDate(new Date(item.expectedDelivery), item.numberOfDays) == 'warning') {
        return 'bg-warning text-warning'
      }
      return 'bg-danger text-danger'
    },
    
    async getRfqItems(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        row.toggleAll = false;
        await this.wait(1000);
        this.$store
          .dispatch("inspectioncontract/GetInspectionContractItemsPending", row.rfqSupplierId)
          .then((res) => {
            res.data.forEach((y) => {
              y.supplierOffer = y.availableItemsForIar > 0 ? true : false;
              y.requestedItem = false;
              y.toggleSelected = false;
              y.empty = y.availableItemsForIar > 0 ? false : true;
              y.sortName = y.apiResourceItemName.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/\s+/g,'').replace(/'/g, '').trim().toLowerCase()
              y.sortDescription = y.apiResourceDescription.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/'/g, '').replace(/\s+/g,'').replace(/[\r\n]/gm, '').trim().toLowerCase();
            });
            row.rfqSupplierOffers = orderBy(res.data, ['sortName', 'sortDescription'], ['asc', 'asc']);
            row.loading = false;
          });
      }
    },
    toggleAll(row) {
      row.rfqSupplierOffers.forEach((item) => {
        if (!item.empty) item.toggleSelected = row.toggleAll;
      });
    },
    checkToggle(row) {
      var count = 0;
      row.rfqSupplierOffers.forEach((item) => {
        if (item.toggleSelected || item.empty) count++;
      });
      if (count === row.rfqSupplierOffers.length) {
        row.toggleAll = true;
      } else {
        row.toggleAll = false;
      }
    },
    printDP(id){
      this.$emit("print-deployment", id);
    },
    getSuspension(item, action) {
      this.$emit("get-suspension", {item, action});
    },
    createIar(item) {
      if (this.hasExtensionWithStatus(item, 'EXTENSION', 'PENDING') || this.hasExtensionWithStatus(item, 'SUSPENSION', 'PENDING')) {
        return this.showToast("Pending contract extension/suspension is still awaiting approval.", "warning");
      }
      this.$emit("create-iar", item);
    },
    viewAttachments(item) {
      this.$emit("view-attachments", item);
    },
    updatePoItem(poData, itemData) {
      this.$emit("update-po-item", { poData, itemData });
    },
    transferCampus(props) {
      this.$emit("transfer-campus", props);
    },
    selectTab(index) {
      this.selectedTab = index;
      this.$emit("tab-selected", index);
    }
  }
}
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between mb-2">
        <h4 class="m-0 pt-3">P.O. List</h4>
        <div class="d-flex align-items-center">
          <div id="tickets-table_filter" class="tableDatas_filter me-1">
            <label class="d-inline-flex align-items-center">
              <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search PO..."
                class="form-control"></b-form-input>
            </label>
          </div>
          <div id="tickets-table_length" class="tableDatas_length">
            <label class="d-inline-flex align-items-center">
              <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
              </b-form-select>
            </label>
          </div>
        </div>
      </div>
      <div v-if="isContract" class="d-flex gap-1 mb-3">
        <div 
          class="border py-2 px-3 rounded cursor-pointer" 
          :class="{'bg-purple text-white': selectedTab == 0}"
          @click="selectTab(0)"
        >Suspended
        </div>
        <div 
          class="border py-2 px-3 rounded cursor-pointer" 
          :class="{'bg-purple text-white': selectedTab == 1}"
          @click="selectTab(1)"
        >Extended
        </div>
        <div 
          class="border py-2 px-3 rounded cursor-pointer" 
          :class="{'bg-purple text-white': selectedTab == 2}"
          @click="selectTab(2)"
        >Terminated
        </div>
        <div 
          class="border py-2 px-3 rounded cursor-pointer" 
          :class="{'bg-purple text-white': selectedTab == 3}"
          @click="selectTab(3)"
        >Cancelled
        </div>
      </div>
      <div class="border p-3 d-flex align-items-center justify-content-center" v-if="loading">
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-25px h-25px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <h5 class="mb-0">Loading...</h5>
      </div>
      <div class="text-center border p-3" v-else-if="paginated.length == 0">
        <div v-if="filter != ''">
          <i class="fas fa-exclamation-triangle me-2"></i>There are no
          POs matching your request
        </div>
        <div v-else>
          <i class="fas fa-exclamation-triangle me-2"></i>No POs
          available
        </div>
      </div>
      <div v-else class="border">
        <div class="text-muted" role="tablist" v-for="(x, index) in paginated" :key="x.id">
          <b-card no-body class="mb-0 border shadow-none"
            :style="`z-index: ${paginated.length - index + 1000}`">
            <RawData :keyId="`${status}-${x.id}`" :data="x" v-if="$store.state.decrypt.isAdmin()" />
            <b-card-header header-tag="header" role="tab">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="d-flex align-items-center" >
                    <div class="text-white">PO# {{ x.poNumber }}</div>
                    <div class="ms-2">|</div>
                    <small class="ms-2">
                      {{ x.supplierName }}
                    </small>
                  </div>
                  <div class="text-white font-size-14" :class="{'mb-1': status.toLowerCase() !== 'completed'}">
                    {{ x.description }}
                  </div>
                  <div class="d-flex align-items-center" >
                    <template v-if="status.toLowerCase() !== 'completed'">
                      <div 
                        v-b-tooltip.bottomleft.hover="'Expected Date of Delivery'" 
                        class="badge bg-soft" 
                        :class="deliveryClass(x)"
                      >
                        <b class="font-size-12">{{
                          formatDate(new Date(x.expectedDelivery))
                        }}</b>
                      </div> <span v-if="!x.visible && (hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') ||
                        hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING'))"
                        class="badge bg-danger rounded-pill ms-1 position-relative">!</span>
                      <div class="ms-2">|</div>
                    </template>
                    <small :class="{ 'ms-1': status.toLowerCase() !== 'completed' }">
                      <a href="javascript: void(0);" class="text-success d-flex align-items-center"
                        :class="{'ms-1': status.toLowerCase() !== 'completed'}"
                        @click="getRfqItems(x)">
                        {{ x.visible ? "Hide" : "Show" }}
                        Details
                        <i class="bx bx-chevron-right rotate font-size-14" :class="{
                          'rotate-90': x.visible
                        }"></i>
                      </a>
                    </small>
                  </div>
                </div>
                <div 
                  v-if="!viewOnly" 
                  class="float-end d-flex align-items-center"
                >
                  <button type="button" class="btn btn-sm d-flex align-items-center justify-content-center"
                    @click="printDP(x.id)"
                  >
                    <i class="bx bx-printer text-purple font-size-20"></i>
                  </button>
                  <i 
                    class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" 
                    :id="`incoming-popover-${status}-${x.id}`"
                    tabindex="0"></i>
                  <b-popover 
                    :target="`incoming-popover-${status}-${x.id}`" 
                    triggers="click blur" 
                    placement="leftbottom"
                    variant="secondary" 
                    custom-class="p-0"
                  >
                    <b-list-group class="w-100 fit">
                      <b-list-group-item 
                        v-if="!x.visible" 
                        button 
                        action
                        class="d-flex align-items-center text-warning" 
                        @click="getSuspension(x, 'CREATE')"
                      >
                        <i class="mdi mdi-calendar-clock font-size-18 me-1"></i>Show Contract Management
                      </b-list-group-item>
                      <b-list-group-item 
                        button 
                        action 
                        class="d-flex align-items-center text-info"
                        @click="transferCampus(x)">
                        <i class="mdi mdi-transfer font-size-18 me-1"></i>Transfer {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                      </b-list-group-item>
                    </b-list-group>
                  </b-popover>
                </div>
              </div>
            </b-card-header>
            <b-collapse class="border-bottom border-5" :visible="x.visible" :accordion="`po-accordion-${status}-${x.id}`"
              role="tabpanel">
              <b-card-body
                class="border border-3 border-bottom-0 border-start-0 border-end-0 custom-table-responsive">
                <div class="mb-2">
                  <div class="d-flex justify-content-between">
                    <b class="mt-2 mb-1 font-size-16">Incoming Items:</b>
                    <div class="d-flex align-items-center">
                      <div class="d-flex gap-2">
                        <div v-if="!viewOnly"> 
                          <button 
                            type="button" 
                            @click="getSuspension(x, 'CREATE')"
                            class="btn btn-sm btn-warning d-flex align-items-center justify-content-center">
                            <i class="mdi mdi-calendar-clock fs-6 me-1"></i>Show Contract Management
                          </button>
                          <span 
                            v-if="hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') || hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING')"
                            class="badge bg-danger rounded-pill position-relative"
                            style="bottom: 38px; left: 240px">!</span>
                        </div>
                        <div v-if="!viewOnly">
                          <button class="btn btn-primary btn-sm" @click="viewAttachments(x)"><i class="mdi mdi-paperclip fs-6 me-1"></i> Attachments</button>
                        </div>
                      </div>
                      <transition>
                        <button 
                          v-if="selectedRowCheck(x.rfqSupplierOffers)"
                          type="button" 
                          @click="createIar(x)"
                          class="btn btn-sm btn-success ms-2 d-flex align-items-center">
                          <i class="mdi mdi-truck-outline fs-6 me-1"></i>
                          Delivery
                        </button>
                      </transition>
                    </div>
                  </div>
                </div>
                <div v-if="x.loading" class="p-3 border d-flex align-items-center justify-content-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-25px h-25px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <h5 class="mb-0">Loading...</h5>
                </div>
                <div class="p-3 border d-flex align-items-center justify-content-center"
                  v-else-if="x.rfqSupplierOffers.length == 0">
                  <h5 class="text-muted">
                    <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
                  </h5>
                </div>
                <div v-else>
                  <table width="100%">
                    <thead>
                      <tr>
                        <th class="py-2" style="min-width: 400px">
                          <div class="row m-0">
                            <div class="col-6 p-0 pe-5">
                              <b>Supplier Offer:</b>
                            </div>
                            <div class="col-6 p-0 pe-5">
                              <b>Requested Item:</b>
                            </div>
                          </div>
                        </th>
                        <th class="py-2" style="width: 250px">
                          Requisitioning Office/Dept.:
                        </th>
                        <th class="py-2" style="width: 150px">
                          Unit Price
                        </th>
                        <th class="py-2" style="width: 150px">
                          Items Remaining
                        </th>
                        <th class="py-2" style="width: 70px">
                          Actions
                        </th>
                        <th v-if="!viewOnly" class="py-2" style="width: 30px">
                          <div class="form-check form-checkbox-outline form-check-success mb-0">
                            <input type="checkbox" :id="`checkbox-${x.id}`" checked="checked"
                              class="form-check-input" @change="toggleAll(x)"
                              v-model="x.toggleAll" /><label :for="`checkbox-${x.id}`"
                              class="form-check-label">
                              All
                            </label>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="y in x.rfqSupplierOffers" :key="y.id" class="border-top">
                        <td class="py-2 align-top">
                          <div class="row m-0">
                            <div class="col-6 p-0 pe-5">
                              <div>
                                {{ y.itemName }}
                              </div>
                              <small>{{ y.description }}</small>
                            </div>
                            <div class="col-6 p-0 pe-5">
                              <div>
                                {{ y.apiResourceItemName }}
                              </div>
                              <small>{{
                                y.apiResourceDescription
                              }}</small>
                            </div>
                          </div>
                        </td>
                        <td class="py-2 align-top">
                          <div>{{ x.endUser }}</div>
                          <small>{{ x.deliveryUnit }}</small>
                        </td>
                        <td class="py-2 align-top text-warning">
                          {{ formatCurrency(y.unitCost) }}
                        </td>
                        <td class="py-2 align-top text-info">
                          {{ y.availableItemsForIar }} of
                          {{ y.quantity }}
                        </td>
                        <td v-if="!viewOnly" style="min-width: 70px" class="py-1 align-top">
                          <i title="Edit Item" @click="updatePoItem(x, y)"
                            class="mdi mdi-pencil font-size-18 text-info cursor-pointer ms-3"></i>
                        </td>
                        <td v-if="!viewOnly" class="py-2 align-top">
                          <div class="form-check form-checkbox-outline form-check-success mb-0">
                            <input type="checkbox" :id="`apiID-${x.id}-${y.id}`" class="form-check-input"
                              @change="checkToggle(x)" v-model="y.toggleSelected"
                              :disabled="y.empty ? true : false" />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
      <div class="row pt-3 pb-3">
        <div v-if="rows > 0" class="col">
          Showing {{ (currentPage - 1) * perPage + 1 }} -
          {{
            rows > (currentPage - 1) * perPage + perPage
              ? (currentPage - 1) * perPage + perPage
              : rows
          }}
          of {{ rows }}
        </div>
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="paginate pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>